import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkoutActions, userActions } from '@detox/actions';
import { KeyValue } from '../../types/common.types';
import CONSTANTS from '../../constants/checkout';

interface UserState {
  information: {
    anonymousUser: boolean;
    clientContext: KeyValue;
  };
}

interface RootState {
  user: UserState;
  checkout: KeyValue;
  ekyc: KeyValue;
}

const { getUserInformation } = userActions;
const { getCallerByContact } = checkoutActions;

export const isExistingOrReconCustomer = (checkoutFlow: string): boolean =>
  [CONSTANTS.CHECKOUT_RECON].includes(checkoutFlow);

const useUser = (isNewNewCheckout = false): KeyValue => {
  const dispatch = useDispatch();
  const {
    userInformation,
    verificationData,
    checkout,
    ekycState
  } = useSelector((state: RootState) => {
    return {
      userInformation: state.user.information,
      verificationData: state.checkout?.verificationData,
      checkout: state.checkout,
      ekycState: state.ekyc
    };
  });
  const hasUserInfo = Boolean(userInformation);
  const hasUserInfoContext = Boolean(userInformation?.clientContext);
  const isUserLoggedIn = Boolean(
    hasUserInfo && !userInformation?.anonymousUser
  );

  useEffect(() => {
    if (
      !hasUserInfo &&
      (ekycState?.verifyEkycPayload?.contactId ||
        ekycState?.verifyEkycPayload?.ekycFlag === 'false')
    ) {
      dispatch(
        getUserInformation(
          isExistingOrReconCustomer(checkout?.checkoutFlow) && {
            updateCache: true
          }
        )
      );
    }
  }, [hasUserInfo, ekycState?.verifyEkycPayload]);

  useEffect(() => {
    if (
      hasUserInfo &&
      verificationData &&
      !hasUserInfoContext &&
      !isNewNewCheckout
    ) {
      const { id: passId, passType } = verificationData;
      dispatch(getCallerByContact({ passType, passId }));
    }
  }, [hasUserInfo, hasUserInfoContext, verificationData, isNewNewCheckout]);

  return { isUserLoggedIn, hasUserInfo };
};

export default useUser;
